import type { FinancialStatementGeneralSettings } from "../../../../../../../../api/types/svTypes.ts";

export const getHideBlankRowsSettingsChanges = (hideBlankRows: boolean): Partial<FinancialStatementGeneralSettings> =>
  hideBlankRows ? { hideBlankRows } : { hideBlankRows, hideZeroRows: false };
